export enum JobViewConcludedEventNames {
  JOB_PAGE_VIEWED = 'customer dashboard - concluded jobs page view',
  PROFILE_CLICKED = 'customer dashboard - concluded jobs pros profile clicked',
  REBOOK_CLICKED = 'customer dashboard - concluded jobs rebook pro clicked',
  REVIEW_CLICKED = 'customer dashboard - concluded jobs review pro clicked'
}
